
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for/compliance-officers",
      function () {
        return require("private-next-pages/for/compliance-officers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for/compliance-officers"])
      });
    }
  